import Shoe from './Shoe'

export default Shoe
